// src/components/TopBar.jsx
import React from 'react';
import Icon from '../shared/components/Icon';
import { uiText } from '../shared/constants/uiText';
// import NotificationBell from '../features/notifications/components/NotificationBell';

export default function TopBar({ search, setSearch, activeView = 'overview' }) {
  const isSettingsView = activeView === 'settings';
  const pageTitle = isSettingsView ? 'Settings' : 'Overview';

  return (
    <header className="topbar">
      <div className="crumb">
        <span className="crumb-section">Service Desk</span>
        <Icon name="chevron-right" size={13} />
        <span className="crumb-page">{pageTitle}</span>
      </div>
      {/* {!isSettingsView && (
        <div className="searchbox">
          <Icon name="search" size={15} />
          <input
            placeholder={uiText('SEARCH_PLACEHOLDER')}
            value={search}
            onChange={e => setSearch(e.target.value)}
            autoComplete="off"
            spellCheck={false}
          />
          {search && (
            <button
              onClick={() => setSearch('')}
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--muted)', padding: '0 4px' }}
              aria-label="Clear search"
            >
              <Icon name="x" size={13} />
            </button>
          )}
        </div>
      )} */}
      {/* <div className="topbar-actions">
        <NotificationBell />
      </div> */}
    </header>
  );
}
